export const arrowDown16 = "M9 2v10.295l1.62-1.62.706.707-2.808 2.81-2.81-2.81.707-.707L8 12.26V2z";
